import type { Result } from "@/components/ui/box.schema";
import type { SingleInvitationResult } from "@/lib/api/invitations";
import { confirmed, refused, recover } from "@/components/admissions/admissions-state";
export function invitationResult(answer: SingleInvitationResult, key: string, sentence: string, refresh: () => void, onConfirmed?: (answer: SingleInvitationResult) => void): Result {
  if (answer.state === "confirmed") { onConfirmed?.(answer); refresh(); return confirmed([sentence]); }
  if (answer.state === "refused") { refresh(); return refused(answer.reason?.message ?? "The invitation change was refused."); }
  return recover<SingleInvitationResult>(key, result => invitationResult(result, key, sentence, refresh, onConfirmed));
}
